/* Judy Paint – Slider, Einblenden, Wechseltexte für die mii-Vorlagen (Auftrag 014). */
(function () {
  if (window.__miiLook) return;
  window.__miiLook = true;

  function initSlider(root) {
    if (root.__mii) return;
    root.__mii = true;
    var track = root.querySelector('.mii-track');
    if (!track) return;
    var prev = root.querySelector('[data-mii-prev]');
    var next = root.querySelector('[data-mii-next]');
    var dots = root.querySelector('.mii-dots');
    var items = Array.prototype.slice.call(track.children);
    function step() { return items[0] ? items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 20) : track.clientWidth; }
    function pages() { return Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step()) + 1); }
    function current() { return Math.round(track.scrollLeft / step()); }
    function drawDots() {
      if (!dots) return;
      var n = pages();
      if (dots.children.length !== n) {
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var s = document.createElement('span');
          s.dataset.i = i;
          s.addEventListener('click', function (e) { track.scrollTo({ left: e.target.dataset.i * step(), behavior: 'smooth' }); });
          dots.appendChild(s);
        }
      }
      var c = current();
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === c); });
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2 && root.dataset.loop !== 'true';
      if (next) next.disabled = track.scrollLeft >= max && root.dataset.loop !== 'true';
      var nav = root.querySelector('.mii-nav');
      if (nav) nav.style.display = track.scrollWidth > track.clientWidth + 4 ? '' : 'none';
      drawDots();
    }
    function go(dir) {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (root.dataset.loop === 'true') {
        if (dir > 0 && track.scrollLeft >= max) return track.scrollTo({ left: 0, behavior: 'smooth' });
        if (dir < 0 && track.scrollLeft <= 2) return track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      }
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    var auto = parseInt(root.dataset.autoplay || '0', 10);
    if (auto > 0) {
      var paused = false;
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      setInterval(function () { if (!paused && document.visibilityState === 'visible') go(1); }, auto * 1000);
    }
  }

  function initFade(el) {
    if (el.__miiFade) return;
    el.__miiFade = true;
    if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -40px 0px' });
    io.observe(el);
  }

  function initRotator(root) {
    if (root.__mii) return;
    root.__mii = true;
    var items = root.querySelectorAll('[data-mii-item]');
    if (items.length < 2) return;
    var dots = root.querySelectorAll('.mii-dots span');
    var i = 0;
    var ms = parseInt(root.dataset.interval || '5000', 10);
    function show(n) {
      items[i].hidden = true; if (dots[i]) dots[i].classList.remove('is-on');
      i = n; items[i].hidden = false; if (dots[i]) dots[i].classList.add('is-on');
    }
    Array.prototype.forEach.call(dots, function (d, n) { d.addEventListener('click', function () { show(n); }); });
    setInterval(function () { show((i + 1) % items.length); }, ms);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mii-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('.mii-fade').forEach(initFade);
    (scope || document).querySelectorAll('[data-mii-rotator]').forEach(initRotator);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.miiLookInit = initAll;
})();
